module.exports = __webpack_public_path__ + "static/img/shape-1.327e4292.svg";